import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

export default function AutoAwesome(props:any) {
  return (
    <SvgIcon {...props}>
      <path d="M12 2l1.5 4.5L18 8l-4.5 1.5L12 14l-1.5-4.5L6 8l4.5-1.5z" />
    </SvgIcon>
  )
}
